/**
 * Created by mgoria on 10/31/15.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InvalidCognitoIdentityException = undefined;

var _Exception2 = require('../../../Exception/Exception');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Thrown when context identity pool id does not much identity pool id from security service
 */
let InvalidCognitoIdentityException = exports.InvalidCognitoIdentityException = function (_Exception) {
  _inherits(InvalidCognitoIdentityException, _Exception);

  /**
   * @param {String} identityPoolId
   */
  function InvalidCognitoIdentityException(identityPoolId) {
    _classCallCheck(this, InvalidCognitoIdentityException);

    return _possibleConstructorReturn(this, (InvalidCognitoIdentityException.__proto__ || Object.getPrototypeOf(InvalidCognitoIdentityException)).call(this, `Invalid cognito identity pool "${identityPoolId}".`, 403));
  }

  return InvalidCognitoIdentityException;
}(_Exception2.Exception);


//////////////////
// WEBPACK FOOTER
// ../~/deep-core/lib.compiled/AWS/Lambda/Exception/InvalidCognitoIdentityException.js
// module id = 362
// module chunks = 0